<template>
  <div class="container-fluid m-0 p-0" v-if="user">
    <div class="row">
      <div class="col-12">
        <div class="card my-4">
          <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
            <div
              class="bg-gradient-success shadow-success border-radius-lg pt-4 pb-3"
            >
              <h6 class="text-white text-capitalize ps-3">Ranking</h6>
            </div>
          </div>

          <div class="card-body p-4">
            <v-container>
              <v-row>
                <v-col v-if="user.role === 'ADMIN'">
                  <DefaultSelect
                    label="Selecione um usuário"
                    :options="users"
                    itemText="full_name"
                    itemValue="id"
                    @change="handleUser"
                    placeholder="Selecione..."
                  />

                  <DefaultSelect
                    v-if="userSelected"
                    label="Selecione uma campanha"
                    :options="raffles"
                    itemText="name"
                    itemValue="id"
                    @change="handleCampaign"
                    placeholder="Selecione..."
                  />
                </v-col>
                <v-col v-else>
                  <DefaultSelect
                    label="Selecione uma campanha"
                    :options="raffles"
                    itemText="name"
                    itemValue="id"
                    @change="handleCampaign"
                    placeholder="Selecione..."
                  />
                </v-col>
                <v-col>
                  <DefaultSelect
                    v-if="selectedCampaign"
                    v-model="selectedFilter"
                    :options="filterOptions"
                    label="Filtrar por"
                    placeholder="Selecione..."
                    @update:model-value="applyFilter"
                  />
                </v-col>
              </v-row>
              <div v-if="selectedFilter === 'hourly'" class="row align-items-end mt-2">
                <div class="col-12 col-md-3 mb-3 mb-md-0">
                  <label class="text-xs text-uppercase text-body font-weight-bolder">Data</label>
                  <input type="date" class="form-control input-default" v-model="hourlyDate" />
                </div>
                <div class="col-12 col-md-3 mb-3 mb-md-0">
                  <label class="text-xs text-uppercase text-body font-weight-bolder">Início</label>
                  <input type="time" class="form-control input-default" v-model="hourlyStart" />
                </div>
                <div class="col-12 col-md-3 mb-3 mb-md-0">
                  <label class="text-xs text-uppercase text-body font-weight-bolder">Fim</label>
                  <input type="time" class="form-control input-default" v-model="hourlyEnd" />
                </div>
                <div class="col-12 col-md-3">
                  <button class="btn btn-success mb-0 w-100" style="height: 43px;" @click="applyFilter">Filtrar</button>
                </div>
              </div>
            </v-container>

            <div class="table-responsive p-0 ranking-table mt-4">
              <template v-if="ranking.length > 0">
                <table class="table align-items-center mb-0" id="data-table">
                  <thead>
                    <tr>
                      <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                        Posição / Nome
                      </th>
                      <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                        Telefone
                      </th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                        Valor
                      </th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                        Cotas
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(r, index) in ranking"
                      :key="r.id"
                      class="ranking-row"
                    >
                      <td>
                        <div class="d-flex px-2 py-1 align-items-center">
                          <div v-if="index === 0" class="medal medal-gold me-3">🥇</div>
                          <div v-else-if="index === 1" class="medal medal-silver me-3">🥈</div>
                          <div v-else-if="index === 2" class="medal medal-bronze me-3">🥉</div>
                          <span v-else class="text-sm font-weight-bold grey-rank me-3">{{ index + 1 }}º</span>
                          <div class="d-flex flex-column justify-content-center">
                            <h6 class="mb-0 text-sm">{{ r.name }}</h6>
                          </div>
                        </div>
                      </td>
                      <td>
                        <p class="text-xs font-weight-bold mb-0">
                        {{ getTelephone(r.phone) }}
                        </p>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="badge-money">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="size-4"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="currentColor"
                            aria-hidden="true"
                            data-slot="icon"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                            ></path>
                          </svg>
                          {{
                            r.total_value.toLocaleString("pt-br", {
                              style: "currency",
                              currency: "BRL",
                            })
                          }}
                        </span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <div class="d-flex justify-content-center">
                          <p class="badge-blue">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke-width="1.5"
                              stroke="currentColor"
                              aria-hidden="true"
                              data-slot="icon"
                              class="size-4"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="M16.5 6v.75m0 3v.75m0 3v.75m0 3V18m-9-5.25h5.25M7.5 15h3M3.375 5.25c-.621 0-1.125.504-1.125 1.125v3.026a2.999 2.999 0 0 1 0 5.198v3.026c0 .621.504 1.125 1.125 1.125h17.25c.621 0 1.125-.504 1.125-1.125v-3.026a2.999 2.999 0 0 1 0-5.198V6.375c0-.621-.504-1.125-1.125-1.125H3.375Z"
                              ></path>
                            </svg>
                            {{ r.total_quotas }} cotas
                          </p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </template>
              <template v-else>
                <div class="no-data-message">
                  <p>Selecione uma campanha para o ranking ser exibido.</p>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Loading v-if="loading" />
  </div>
</template>

<script>
import Loading from "@/components/Loading.vue";
import DefaultSelect from "@/components/DefaultSelect.vue";
import LoggingMixin from "@/mixins/LoggingMixin.js";

import UsersHttp from "@/http/UsersHttp.js";
import RafflesHttp from "@/http/RafflesHttp.js";
import ParticipantsHttp from "@/http/ParticipantsHttp.js";
import { getTelephone } from "@/helpers/phoneNumber.js";
export default {
  name: "ranking",
  mixins: [LoggingMixin],
  components: {
    Loading,
    DefaultSelect,
  },
  data() {
    return {
      user: null,
      userSelected: null,
      raffles: [],
      ranking: [],
      pages: 0,
      loading: true,
      filterOptions: [
        { label: "Sem filtro", value: "unfiltered" },
        { label: "Hoje", value: "today" },
        { label: "Esta semana (últimos 7 dias)", value: "week" },
        { label: "Este mês (últimos 30 dias)", value: "month" },
        { label: "Filtrar Por Hora", value: "hourly" },
      ],
      selectedFilter: null,
      selectedCampaign: null,
      hourlyDate: null,
      hourlyStart: null,
      hourlyEnd: null,
    };
  },
  async mounted() {
    this.user = this.$store.getters.user;
    await this.init();
  },
  watch: {
    "$store.state.isDarkMode": function () {
      if (this.$store.state.isDarkMode) {
        document.querySelectorAll(".input-default").forEach((el) => {
          el.classList.add("dark-mode-input");
        });
      } else {
        document.querySelectorAll(".input-default").forEach((el) => {
          el.classList.remove("dark-mode-input");
        });
      }
    },
  },
  methods: {
    getTelephone,
    async init() {
      this.loading = true;

      if (this.user.role === "ADMIN") {
        await this.getUsers();
      }

      if (this.user.role === "USER") {
        await this.getRaffles();
      }

      this.loading = false;
    },
    async getUsers() {
      try {
        const response = await UsersHttp.getUsersMinimum();
        this.users = response.data;
      } catch (error) {
        console.error(error);
      }
    },
    async handleUser(e) {
      let id_user = e.target.value;
      this.ranking = [];
      this.userSelected = id_user;
      await this.getRafflesByUserId(id_user);
    },
    async getRaffles() {
      try {
        const response = await RafflesHttp.getRafflesMinimum();
        this.raffles = response.data;
      } catch (error) {
        this.$toast.add({
          severity: "error",
          summary: "Ops...",
          detail: "Houve um erro ao buscar as campanhas.",
          life: 3000,
        });
        console.error(error);
      }
    },
    async getRafflesByUserId(id) {
      try {
        this.loading = true;

        const response = await RafflesHttp.getRafflesByUser(id);
        this.raffles = response.data;
      } catch (error) {
        console.error(error);
        this.$toast.add({
          severity: "error",
          summary: "Ops...",
          detail: "Houve um erro ao buscar as campanhas.",
          life: 3000,
        });
      } finally {
        this.loading = false;
      }
    },
    async getRanking(idCampaign) {
      try {
        this.loading = true;

        const response = await ParticipantsHttp.getRanking(idCampaign, 1);
        this.ranking = response.data.data;
        this.pages = response.data.pages;
      } catch (error) {
        this.$toast.add({
          severity: "error",
          summary: "Ops...",
          detail: "Houve um erro ao buscar o ranking.",
          life: 3000,
        });
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async handleCampaign(e) {
      this.ranking = [];
      this.pages = 0;
      this.loading = true;
      this.selectedFilter = "unfiltered";
      await this.getRanking(e.target.value);
      this.selectedCampaign = e.target.value;
      this.loading = false;
    },
    async applyFilter() {
      const today = new Date();
      const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      };

      let initialDate = `${formatDate(today)} 00:00:00`;
      let finalDate = `${formatDate(today)} 23:59:59`;

      if (this.selectedFilter === "hourly") {
        if (!this.hourlyDate || !this.hourlyStart || !this.hourlyEnd) {
          this.$toast.add({
            severity: "warn",
            summary: "Atenção",
            detail: "Preencha a data e os horários de início e fim.",
            life: 3000,
          });
          return;
        }
        initialDate = `${this.hourlyDate} ${this.hourlyStart}:00`;
        finalDate = `${this.hourlyDate} ${this.hourlyEnd}:59`;
      } else if (this.selectedFilter === "week") {
        const startOfWeek = new Date(today);
        startOfWeek.setDate(today.getDate() - 7);
        initialDate = `${formatDate(startOfWeek)} 00:00:00`;
      } else if (this.selectedFilter === "month") {
        const startOfMonth = new Date(today);
        startOfMonth.setDate(today.getDate() - 30);
        initialDate = `${formatDate(startOfMonth)} 00:00:00`;
      } else if (this.selectedFilter === "unfiltered") {
        initialDate = null;
        finalDate = null;
        this.getRanking(this.selectedCampaign);
        return;
      }

      this.fetchRankingByDate(initialDate, finalDate);
    },
    async fetchRankingByDate(initial, final) {
      try {
        this.loading = true;

        const response = await ParticipantsHttp.getRanking(
          this.selectedCampaign,
          1,
          {
            initial: initial,
            final: final,
          }
        );
        this.ranking = response.data.data;
        this.pages = response.data.pages;
      } catch (error) {
        this.$toast.add({
          severity: "error",
          summary: "Ops...",
          detail: "Houve um erro ao buscar o ranking filtrado.",
          life: 3000,
        });
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.input-default {
  width: 100%;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
}

.dark-mode-input {
  background-color: #1a2035 !important;
  border: 1px solid #10131f !important;
  color: #fff;
}
.badge-money {
  display: inline-flex;
  align-items: center;
  border-radius: 0.375rem;
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity));
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity));
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0
    var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0
    calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow),
    var(--tw-shadow, 0 0 #0000);
  --tw-ring-inset: inset;
  --tw-ring-color: rgb(22 163 74 / 0.2);
  border: 1pt solid #16a34a;
}
.badge-blue {
  display: flex;
  max-width: -moz-max-content;
  max-width: max-content;
  align-items: center;
  gap: 0.5rem;
  border-radius: 9999px;
  padding: 0.125rem 0.75rem;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 600;
  text-transform: uppercase;
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity));
  margin: 0 !important;
}
.size-4 {
  width: 1rem;
  height: 1rem;
}

.ranking-row {
  transition: background-color 0.2s ease;
}

.ranking-row:hover {
  background-color: rgba(228, 27, 128, 0.05);
}

.medal {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  border-radius: 50%;
  background: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.medal-gold {
  border: 2px solid #ffd700;
  background: linear-gradient(135deg, #fff 0%, #fff9e6 100%);
}
.medal-silver {
  border: 2px solid #c0c0c0;
  background: linear-gradient(135deg, #fff 0%, #f2f2f2 100%);
}
.medal-bronze {
  border: 2px solid #cd7f32;
  background: linear-gradient(135deg, #fff 0%, #f9f2ec 100%);
}

.grey-rank {
  color: #adb5bd;
  width: 40px;
  text-align: center;
  display: inline-block;
}

.no-data-message {
  text-align: center;
  font-size: 1.2rem;
}
</style>